import { MaskedLine, FadeIn, SectionHead } from "./Shared";

export default function About() {
  return (
    <section id="about" className="relative py-16 md:py-24 border-t border-white/10" data-testid="about-section">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <SectionHead index="04" kicker="About" title="The" accent="Operator" />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <FadeIn>
              <div className="relative">
                <div className="aspect-[4/5] overflow-hidden cinema-mask">
                  <img
                    src="/media/about-diego.jpg"
                    alt="Diego Tomazo — on the shoot"
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute -bottom-5 -right-5 hidden sm:block">
                  <div className="bg-gold text-black px-6 py-4">
                    <p className="font-display font-extrabold uppercase tracking-tight leading-none">tomazo</p>
                    <p className="font-mono text-[10px] tracking-[0.3em] mt-1">.PRODUCTIONS</p>
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>

          <div className="lg:col-span-7">
            <MaskedLine>
              <h3 className="font-display text-3xl md:text-5xl font-bold uppercase tracking-tight leading-[1.02]">
                Diego Tomazo<span className="text-gold">.</span>
              </h3>
            </MaskedLine>
            <FadeIn delay={0.1}>
              <p className="mt-6 text-sm md:text-base text-zinc-400 leading-relaxed max-w-2xl">
                Freelance photographer and videographer based in the Greater Toronto Area, shooting under the
                tomazo.productions name. The work lives where precision meets adrenaline — automotive portraits and
                rollers, banquet cinematics, and brand films for businesses that want to look the part.
              </p>
            </FadeIn>
            <FadeIn delay={0.18}>
              <blockquote className="mt-8 border-l-2 border-gold pl-6">
                <p className="font-serifaccent italic text-xl md:text-2xl text-zinc-200 leading-snug">
                  “Cinematic videos and sharp, high-value photography delivered at an accessible cost.”
                </p>
                <cite className="block mt-3 font-mono text-[11px] tracking-[0.25em] text-gold not-italic uppercase">— The Tomazo standard</cite>
              </blockquote>
            </FadeIn>
            <FadeIn delay={0.26}>
              <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-gold mt-10">
                Greater Toronto Area — available for travel
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>
  );
}
